import { Object3D } from "three";
import { teamAbbrevToVenueId } from "../../../lib/types/statsApi";
import { Context } from "../../context";

import { PoserClock } from "../../util/clock";
import { IndoorLighting } from "./indoor-lighting";
import { SkyLighting } from "./sky/sky-lighting";

export class LightRig extends Object3D {
  sky?: SkyLighting;
  indoor?: IndoorLighting;

  constructor(context: Context) {
    super();

    const { gameState, options } = context;

    const venueId = options.venueOverride
      ? teamAbbrevToVenueId[options.venueOverride]
      : gameState.getVenueId();
    if (venueId === 12) {
      // special case for TB
      this.indoor = new IndoorLighting();
      this.add(this.indoor);
    } else {
      this.sky = new SkyLighting(context, venueId);
      this.add(this.sky);
    }
  }

  init() {
    this.sky?.init();
  }

  teardown() {
    this.sky?.teardown();
  }

  update(clock: PoserClock) {
    this.sky?.update(clock);
    this.indoor?.update();
  }

  helpersOn(on: boolean) {
    this.sky?.helpersOn(on);
  }
}
